import React from 'react';

const FAQ = () => {
  // You can easily add more questions to this list!
  const faqs = [
    {
      question: "How can I apply for admission?",
      answer: "Admissions are currently open! You can apply by clicking the 'Admissions' tab in the menu and filling out the online form. We will contact you within 24 hours."
    },
    {
      question: "Is there a fee for the courses?",
      answer: "Some of our basic courses are free, while specialized programs have a fee to support our teachers and platform maintenance."
    },
    {
      question: "Do you offer certificates?",
      answer: "Yes, upon successful completion of exams for any course, Darul Uloom Online awards a digital certificate verified by our senior scholars."
    },
    {
      question: "Can I join from any country?",
      answer: "Absolutely! We can teach students from the UK, USA, India, UAE and all over the world!. All you need is an internet connection."
    }
  ];

  return (
    <div className="container my-5">
        <style>
        {`
          /* 1. The Box Border */
          .accordion-item {
            border: 1px solid #c3e6cb; /* Light Green Border */
            margin-bottom: 10px;
            border-radius: 8px !important;
            overflow: hidden;
          }

          /* 2. The Button (When CLOSED) */
          .accordion-button {
            background-color: #fff;
            color: #155724; /* Dark Green Text */
            font-weight: bold;
          }

          /* 3. The Button (When OPEN/ACTIVE) */
          .accordion-button:not(.collapsed) {
            background-color: #d4edda; /* Light Green Background */
            color: #0c4128; /* Darker Green Text */
            box-shadow: none; /* Remove blue glow */
          }

          /* 4. Remove the default blue outline on click */
          .accordion-button:focus {
            box-shadow: none;
            border-color: #c3e6cb;
          }

          /* 5. The Answer Box */
          .accordion-body {
            background-color: #f8f9fa; /* Very Light Grey */
            color: #333;
          }
        `}
      </style>
      <h2 className="text-center mb-4 fw-bold text-dark">
        <span className="text-success">Frequently Asked Questions</span> 
      </h2>
      
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="accordion shadow-sm" id="faqAccordion">
            {faqs.map((faq, index) => (
              <div className="accordion-item" key={index}>
                <h2 className="accordion-header" id={`heading${index}`}>
                  <button 
                    className={`accordion-button ${index !== 0 ? 'collapsed' : ''} fw-bold`} 
                    type="button" 
                    data-bs-toggle="collapse" 
                    data-bs-target={`#collapse${index}`} 
                    aria-expanded={index === 0 ? "true" : "false"} 
                    aria-controls={`collapse${index}`}
                  >
                    {faq.question}
                  </button>
                </h2>
                <div 
                  id={`collapse${index}`} 
                  className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`} 
                  aria-labelledby={`heading${index}`} 
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body text-secondary">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;